<app-general-icon-button
  [buttonStyle]="'inline'"
  [buttonIcon]="params.icon"
  [buttonTooltip]="params.tooltip"
  [buttonTooltipPosition]="params.position"
  (buttonClicked)="onClick($event)"
/>
